export type ExternalCompanyRow = {
  id: string;
  companyName: string;
  isActive: boolean;
  /** Nº de ExternalWork asociados. Con >0 el borrado duro está prohibido. */
  externalWorksCount: number;
};

export type TableProps = {
  data: {
    activeCompanies: ExternalCompanyRow[];
    inactiveCompanies: ExternalCompanyRow[];
  };
  onDeactivate: (id: string) => Promise<void>;
  onActivate: (id: string) => Promise<void>;
  /**
   * Abren los modales de SuperModal (patrón de TeamsManagementTable): la tabla
   * no ejecuta la acción, solo la pide. La confirmación del borrado y el form
   * de renombrado viven en sus submodales.
   */
  onEditCompany: (company: ExternalCompanyRow) => void;
  onDeleteCompany: (company: ExternalCompanyRow) => void;
};

export type SearchbarFilterTypes = (value: string) => void;

export const externalCompaniesColumnNames = {
  companyName: {
    id: 'companyName',
    labelKey: 'tables:headers.company',
  },
  externalWorksCount: {
    id: 'externalWorksCount',
    labelKey: 'tables:headers.usageCount',
  },
};
